
import { Vue, Component } from "vue-property-decorator";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import ApplyForm from "@/components/ApplyForm.vue";
import coverImg from "@/assets/cover.jpg";
import curriculumImg from "@/assets/curriculum.jpg";
import learningImg from "@/assets/learning.jpg";
import alumniImg from "@/assets/alumni.jpg";

@Component({
  components: { Breadcrumb, ApplyForm }
})
export default class EmbaOverview extends Vue {
  coverImg = coverImg;
  curriculumImg = curriculumImg;
  learningImg = learningImg;
  alumniImg = alumniImg;
  List = [{ title: "共创会EMBA", url: "" }];

  breadcrumbList = [
    { name: "首页", url: "/" },
    { name: "关于光华" },
    { name: "共创会EMBA" }
  ];
}
